import React, { useEffect } from 'react';
import { LimitedEditionBanner } from './components/LimitedEditionBanner';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailuresSection } from './components/FailuresSection';
import { MechanismSection } from './components/MechanismSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { WhoIsForSection } from './components/WhoIsForSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen bg-emerald-950 flex flex-col overflow-x-hidden" data-id="element-0">
      <LimitedEditionBanner data-id="element-1" />
      <HeroSection data-id="element-2" />
      <OpeningHook data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <FailuresSection data-id="element-5" />
      <MechanismSection data-id="element-6" />
      <TestimonialsSection data-id="element-7" />
      <WhatYouGetSection data-id="element-8" />
      <WhoIsForSection data-id="element-9" />
      <HowItWorksSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <OfferSection data-id="element-12" />
      <Footer data-id="element-13" />
    </main>;
}